import { create } from "zustand";

const useStore = create((set) => ({
  aboutState: {},
  setAboutState: (aboutState) => set(() => ({ aboutState })),
  calculatorState: {},
  setCalculatorState: (calculatorState) => set(() => ({ calculatorState })),
  tab: 0,
  setTab: (tab) => set(() => ({ tab })),
  formRef: null,
  setFormRef: (ref) => set(() => ({ formRef: ref})),
  faqRef: null,
  setFaqRef: (ref) => set(() => ({ faqRef: ref})),
  globalAlertRef: null,
  setGlobalAlertRef: (alertRef) => set(() => ({ globalAlertRef: alertRef})),
  alertHeight: 0,
  setAlertHeight: (alertHeight) => set(() => ({ alertHeight })),
  showTips: false,
  setShowTips: (showTips) => set(() => ({ showTips })),
  showBanner: false,
  setBanner: (showBanner) => set(() => ({ showBanner })),
}));

export default useStore;